import { assertNonEmpty } from '../shared/branded-id';

export type CategoryNodeId = string & { readonly __brand: 'CategoryNodeId' };

export function CategoryNodeId(raw: string): CategoryNodeId {
  return assertNonEmpty(raw.trim(), raw, 'CategoryNodeId') as CategoryNodeId;
}
